import { render } from "./PPTXPreviewer.vue?vue&type=template&id=6c1c4e2a&scoped=true"
import script from "./PPTXPreviewer.vue?vue&type=script&lang=js"
export * from "./PPTXPreviewer.vue?vue&type=script&lang=js"

import "./PPTXPreviewer.vue?vue&type=style&index=0&id=6c1c4e2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1c4e2a"]])

export default __exports__